module.exports = __webpack_public_path__ + "static/media/note-email-white.13108de7.svg";